import { Pressable, StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import { AppIcon } from "../AppIcon";

type Props = {
	label: string;
	selected: boolean;
	onPress: () => void;
};

export const LessonsTopicChip = ({ label, selected, onPress }: Props) => {
	const theme = useAppTheme();

	return (
		<Pressable
			onPress={onPress}
			accessibilityRole="button"
			accessibilityState={{ selected }}
			accessibilityLabel={label}
			style={({ pressed }) => [
				styles.base,
				{
					backgroundColor: selected
						? theme.colors.secondaryContainer
						: theme.colors.surface,
					borderColor: selected
						? theme.colors.primary
						: theme.colors.outlineVariant,
					borderRadius: theme.roundness * 100,
					opacity: pressed ? 0.88 : 1,
				},
			]}
		>
			{selected && (
				<AppIcon name="check" size={11} color={theme.colors.primary} />
			)}
			<Text
				variant="labelMedium"
				style={{
					color: selected ? theme.colors.primary : theme.colors.onSurface,
				}}
				numberOfLines={1}
			>
				{label}
			</Text>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	base: {
		alignItems: "center",
		alignSelf: "flex-start",
		borderWidth: 1,
		flexDirection: "row",
		gap: 4,
		paddingHorizontal: 13,
		paddingVertical: 5,
	},
});
